import { inspectionActions } from '@redux/slices/inspection';
import { checkOldAndNewArray } from '@services/check-old-and-new-array';
import { getAppDispatch } from '@utilities/dispatch.util';
import { store } from 'redux/store';

const inspectionForManipulationJson = ({ initialLogin, isSettingUpdated, data }) => {
  const { inspection } = store.getState();

  const items = data || [];
  let inspectionForRes = [];
  if (!initialLogin && inspection?.inspectionFormsUserCache?.length && !isSettingUpdated) {
    const combineNewAndOldArray = checkOldAndNewArray({
      oldArray: inspection?.inspectionFormsUserCache,
      oldArrayMap: inspection?.inspectionFormsUserCacheMap,
      newArray: items,
      idName: 'inspectionFormId'
    });

    inspectionForRes = combineNewAndOldArray;
  } else {
    if (items?.length > 0) inspectionForRes = items;
  }

  const inspectionFormsUserCache = inspectionForRes || [];
  let inspectionFormsMapWIthUTSection = {};
  const inspectionFormsUserCacheMap = inspectionFormsUserCache?.reduce((acc, curr) => {
    acc[curr.inspectionFormId] = {
      quickComplete: curr?.quickComplete,
      failureCriteria: curr?.failureCriteria,
      name: curr?.name,
      inspectionFormId: curr?.inspectionFormId,
      inspectionType: curr?.inspectionType
    };
    if (curr?.hasUTSection) {
      inspectionFormsMapWIthUTSection = {
        ...inspectionFormsMapWIthUTSection,
        [curr.inspectionType]: true
      };
    }
    return acc;
  }, {});

  const inspectionFormsUserCacheTypeMap = inspectionFormsUserCache?.reduce((acc, curr) => {
    acc[curr.inspectionType] = {
      name: curr?.name
    };
    return acc;
  }, {});

  const listOfInspectionFormThatHaveUTSection = getListOfInspectionFormThatHaveUTSection({
    forms: inspectionFormsUserCache
  });

  return {
    inspectionFormsUserCache,
    inspectionFormsUserCacheMap,
    inspectionFormsUserCacheTypeMap,
    listOfInspectionFormThatHaveUTSection,
    inspectionFormsMapWIthUTSection
  };
};

const inspectionFormDispatcher = ({ data }) => {
  const dispatch = getAppDispatch();

  dispatch?.(
    inspectionActions.setInspectionFormsUserCache({
      inspectionFormsUserCache: data?.inspectionFormsUserCache,
      inspectionFormsUserCacheMap: data?.inspectionFormsUserCacheMap,
      inspectionFormsUserCacheTypeMap: data?.inspectionFormsUserCacheTypeMap,
      listOfInspectionFormThatHaveUTSection: data?.listOfInspectionFormThatHaveUTSection || [],
      inspectionFormsMapWIthUTSection: data?.inspectionFormsMapWIthUTSection || {}
    })
  );
};

const equipmentFormManipulationJson = ({ data }) => {
  const equipmentFormsUserCache = data || [];

  const equipmentFormsUserCacheMap = equipmentFormsUserCache?.reduce((acc, curr) => {
    acc[curr.id] = { ...curr };
    return acc;
  }, {});
  return {
    equipmentFormsUserCache,
    equipmentFormsUserCacheMap
  };
};

const equipmentFormDispatcher = ({ data }) => {
  const dispatch = getAppDispatch();

  dispatch?.(
    inspectionActions.setEquipmentFormsUserCache({
      equipmentFormsUserCache: data?.equipmentFormsUserCache,
      equipmentFormsUserCacheMap: data?.equipmentFormsUserCacheMap
    })
  );
};

export {
  inspectionForManipulationJson,
  inspectionFormDispatcher,
  equipmentFormManipulationJson,
  equipmentFormDispatcher
};

const getListOfInspectionFormThatHaveUTSection = ({ forms }) => {
  let list = [];

  for (let form of forms) {
    if (form?.hasUTSection) {
      list.push(form?.inspectionType?.toString());
    }
  }
  return list;
};
